"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const loader_1 = require("@app/component/ui/loader");
const modal_sidebar_button_1 = require("@app/component/ui/modal/modal-sidebar/modal-sidebar-button");
const const_1 = require("@app/const");
const plugin_config_1 = __importDefault(require("@app/const/plugin-config"));
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const is_admin_1 = require("@app/util/hooks/is-admin");
const tiers_hooks_1 = require("@app/util/hooks/tiers-hooks");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const i18n_1 = require("@app/util/i18n");
require("./plugin-detail.scss");
function openIntercomWithCustomMessage({ variant, pluginName, tierNumber, }) {
    let message = '';
    if (variant === 'request' && typeof tierNumber === 'number') {
        message = (0, i18n_1.t)('ONLY_ON_REQUEST_CUSTOM_MESSAGE', {
            pluginName,
            tierName: (0, i18n_1.t)(`TIER_NAME.${tierNumber}`),
        });
    }
    else if (variant === 'request') {
        message = (0, i18n_1.t)('ONLY_ON_REQUEST_NO_TIER_CUSTOM_MESSAGE', {
            pluginName,
        });
    }
    else if (variant === 'help') {
        message = (0, i18n_1.t)('NEED_HELP_WITH_PLUGIN_MESSAGE', { pluginName });
    }
    if (window.Intercom) {
        window.Intercom('showNewMessage', message);
    }
    else {
        window.alert('V produkci se otevře kontaktní Intercom chat s následující zprávou: ' +
            message);
    }
}
function PluginDetailModal({ plugin, pluginTier: initialPluginTier, activeTier: initialActiveTier, close, }) {
    const dispatch = (0, store_1.useRootDispatch)();
    const { togglePlugin } = (0, use_plugin_1.usePlugin)();
    const { canWrite } = (0, util_1.useAccessRole)();
    const isAdmin = (0, is_admin_1.useIsAdmin)();
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const calendar = (0, store_1.useRootSelector)((state) => state.calendar);
    const isOpeningStripe = (0, store_1.useRootSelector)((state) => state.loading.includes('load-stripe-url'));
    const tiersQuery = (0, tiers_hooks_1.useTiersQuery)({
        enabled: !initialPluginTier && !initialActiveTier,
    });
    const isUsingTiers = (0, tiers_hooks_1.useIsUsiningTiers)();
    const canUpdateTiers = (0, tiers_hooks_1.useCanUpdateTiers)();
    const resolvedPlugin = (0, useWorkspace_1.useWorkspace)()?.plugins?.find((p) => p?.plugin === plugin?.plugin);
    const pluginConfig = plugin_config_1.default.SUPPORTED_PLUGINS?.find((rec) => rec.id === plugin?.plugin);
    if (!plugin?.plugin || !pluginConfig) {
        close();
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const pluginName = (pluginConfig.name ||
        (0, i18n_1.t)('PLUGIN_NAME.' + pluginConfig.id));
    const pluginTier = initialPluginTier || tiersQuery.getTierForPlugin(plugin?.plugin);
    const activeTier = initialActiveTier || tiersQuery.activeTier;
    const hasAdequateTier = Boolean(activeTier && pluginTier && activeTier.tier >= pluginTier.tier);
    // const isAdmin =
    //   document.querySelector('.ds-adminpanel') ||
    //   window.location.hostname === 'localhost' ||
    //   window.location.hostname === 'app.local.dayswaps.top'
    let footerContent = react_1.default.createElement("div", null);
    const pluginAlwaysEnabled = pluginConfig.requireEnabled || false;
    const isPluginEnabled = resolvedPlugin?.enabled || false;
    const displayInadequateTierFooter = ((!hasAdequateTier && !pluginAlwaysEnabled && !isPluginEnabled) ||
        (!isUsingTiers && isPluginEnabled)) &&
        !isAdmin;
    if (tiersQuery.isLoading) {
        footerContent = (react_1.default.createElement("div", { className: 'plugin-detail__loader' },
            react_1.default.createElement(loader_1.LoaderSVG, null)));
    }
    else if (!isUsingTiers && !isAdmin) {
        footerContent = react_1.default.createElement("div", null);
    }
    else if (displayInadequateTierFooter) {
        const tierOnlyOnRequest = pluginTier?.tier === 4;
        footerContent = (react_1.default.createElement("div", { className: 'plugin-detail__footer' },
            react_1.default.createElement(ui_1.Text, { weight: 'bold', color: 'white', type: 'body-large' }, (0, i18n_1.t)('UPGRADE_TO_HIGHER_TIER_PROMPT')),
            react_1.default.createElement(ui_1.Button, { label: tierOnlyOnRequest
                    ? (0, i18n_1.t)('WS_SETTINGS_CARD_PLUGINS_SETTINGS_ENABLE_REQUEST')
                    : (0, i18n_1.t)('UPGRADE_TIER'), disabled: !canUpdateTiers, style: ui_1.Button.STYLES.CONTAINED, color: 'WHITE', bold: true, loading: isOpeningStripe, onClick: async () => {
                    if (tierOnlyOnRequest) {
                        openIntercomWithCustomMessage({
                            variant: 'request',
                            pluginName,
                            tierNumber: activeTier?.tier,
                        });
                    }
                    else {
                        void util_1.miscUtil.openStripeUI();
                    }
                } })));
    }
    else if (((hasAdequateTier || (isPluginEnabled && isUsingTiers)) &&
        !pluginAlwaysEnabled) ||
        isAdmin) {
        const pluginOnlyOnRequest = pluginConfig.onlyOnRequest && !isAdmin;
        let label;
        if (isPluginEnabled) {
            if (pluginOnlyOnRequest) {
                label = (0, i18n_1.t)('WS_SETTINGS_CARD_PLUGINS_SETTINGS_DISABLE_REQUEST');
            }
            else {
                label = (0, i18n_1.t)('UNINSTALL');
            }
        }
        else {
            if (pluginOnlyOnRequest) {
                label = (0, i18n_1.t)('WS_SETTINGS_CARD_PLUGINS_SETTINGS_ENABLE_REQUEST');
            }
            else {
                label = (0, i18n_1.t)('INSTALL');
            }
        }
        footerContent = (react_1.default.createElement(ui_1.Button, { label: label, disabled: !canWrite(const_1.PERMISSIONS.SETTINGS.PLUGINS), style: ui_1.Button.STYLES.CONTAINED, color: isPluginEnabled ? 'RED' : 'PRIMARY', loading: isLoading, onClick: async () => {
                setIsLoading(true);
                if (pluginOnlyOnRequest) {
                    openIntercomWithCustomMessage({
                        variant: 'request',
                        pluginName,
                        tierNumber: activeTier?.tier,
                    });
                    setIsLoading(false);
                    return;
                }
                if (isPluginEnabled) {
                    await dispatch((0, ac_1.setModal)('confirm', {
                        title: (0, i18n_1.t)('PLUGIN_DEACTIVATE') + ' ' + pluginName,
                        text: (0, i18n_1.t)(pluginConfig.customUninstallMessageKey ??
                            'PLUGIN_DEACTIVATE_MESSAGE.default'),
                        type: ui_1.Alert.TYPES.WARNING,
                        confirmLabel: (0, i18n_1.t)('UNINSTALL'),
                        cancelLabel: (0, i18n_1.t)('CANCEL'),
                        buttonColor: 'red',
                        onConfirm: () => {
                            void togglePlugin(pluginConfig.id, calendar);
                        },
                    }));
                    return;
                }
                try {
                    await togglePlugin(pluginConfig.id, calendar);
                }
                catch (error) {
                    console.log('togglePlugin failed', error);
                }
                finally {
                    close();
                }
            } }));
    }
    return (react_1.default.createElement(ui_1.Modal, { size: 'size-l', testid: 'plugin-detail-modal', noClose: isLoading, headerContent: react_1.default.createElement("div", { className: 'ds-title' },
            (0, i18n_1.t)('PLUGIN'),
            ": ",
            pluginName), footerContent: footerContent, footerWithoutPadding: displayInadequateTierFooter, sidebarContent: react_1.default.createElement("div", { className: 'plugin-detail__sidebar' },
            react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { style: { alignItems: 'center', cursor: 'default' } },
                react_1.default.createElement(ui_1.Icon, { size: ui_1.Icon.SIZES.SMALL, ico: 'template' }),
                react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.HORIZONTAL, size: ui_1.Spacing.SIZES.SIZE_8 }),
                react_1.default.createElement(ui_1.Text, { weight: 'bold', color: 'inherit', type: 'body-large' }, (0, i18n_1.t)('OVERVIEW'))),
            react_1.default.createElement(ui_1.Flex, { direction: ui_1.Flex.DIRECTION.COLUMN },
                react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { style: { alignItems: 'center' }, onClick: () => {
                        openIntercomWithCustomMessage({
                            variant: 'help',
                            pluginName,
                        });
                    } },
                    react_1.default.createElement(ui_1.Icon, { size: ui_1.Icon.SIZES.SMALL, ico: 'area-manager' }),
                    react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.HORIZONTAL, size: ui_1.Spacing.SIZES.SIZE_8 }),
                    react_1.default.createElement(ui_1.Text, { weight: 'bold', color: 'inherit', type: 'body-large' }, (0, i18n_1.t)('CONTACT_SUPPORT_BUTTON'))),
                react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.VERTICAL, size: ui_1.Spacing.SIZES.SIZE_8 }),
                react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { style: { alignItems: 'center' }, onClick: () => {
                        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                        window.open((0, i18n_1.t)('LANDING_HELP_URL'), '_blank');
                    } },
                    react_1.default.createElement(ui_1.Icon, { size: ui_1.Icon.SIZES.SMALL, ico: 'help' }),
                    react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.HORIZONTAL, size: ui_1.Spacing.SIZES.SIZE_8 }),
                    react_1.default.createElement(ui_1.Text, { weight: 'bold', color: 'inherit', type: 'body-large' }, (0, i18n_1.t)('HELP'))))) },
        react_1.default.createElement("div", { className: 'plugin-detail-modal' },
            react_1.default.createElement("div", { className: 'content' },
                react_1.default.createElement("div", { className: 'description' },
                    react_1.default.createElement(ui_1.Text, { weight: 'semi-medium', color: 'gray', type: 'body-large' }, (0, i18n_1.t)('PLUGIN_PERKS.' + pluginConfig.id))),
                activeTier?.tier ? (react_1.default.createElement("div", { className: 'current-tier-info' },
                    react_1.default.createElement(ui_1.Alert, { type: 'INFO', variant: 'SLIM', size: 'FULL_WIDTH', text: (0, i18n_1.t)('YOUR_ACTIVE_TIER_LABEL') +
                            ': ' +
                            (0, i18n_1.t)(`TIER_NAME.${activeTier?.tier}`) }))) : (false)))));
}
exports.default = PluginDetailModal;
